<mat-card class="large-card">
    <div class="settingsBody">
        <div class="settings-heading">Manage Enrollments</div>

        <mat-tab-group
            #example1
            (selectedTabChange)="logTab($event)"
            ActiveTabIndex="tab"
            useAutomaticActivation
            class="settings"
        >
            <mat-tab *ngFor="let tab of tabs" [label]="tab.label" class="settings"></mat-tab>
        </mat-tab-group>

        <ng-container *ngIf="tab === 0">
            <div class="employee-add-button-area">
                <button
                    class="add-new-button"
                    type="button"
                    mat-raised-button
                    (click)="toggleAddMenu()"
                >
                    <i class="fal fa-plus-square" A></i>
                    &nbsp; NEW
                </button>
            </div>
            <kendo-grid
                [data]="gridView"
                [selectable]="true"
                style="height: auto"
                [headerClass]="'reports-header'"
                [headerStyle]="{
                    'text-align': 'left',
                    'background-color': '#223540',
                    color: '#FFFFFF',
                    'border-color': '#223540'
                }"
            >
                <kendo-grid-column
                    field="name"
                    title="Enrollment"
                    [width]="200"
                    [headerClass]="'reports-header'"
                    [headerStyle]="{
                        'text-align': 'left',
                        'background-color': '#223540',
                        color: '#FFFFFF',
                        'border-color': '#223540'
                    }"
                ></kendo-grid-column>
                <kendo-grid-column
                    field="description"
                    title="Description"
                    [width]="600"
                    [headerClass]="'reports-header'"
                    [headerStyle]="{
                        'text-align': 'left',
                        'background-color': '#223540',
                        color: '#FFFFFF',
                        'border-color': '#223540'
                    }"
                ></kendo-grid-column>
                <kendo-grid-column title="Active">
                    <ng-template kendoGridCellTemplate let-record>
                        <span *ngIf="record.isActive">Yes</span>
                        <span *ngIf="!record.isActive">No</span>
                    </ng-template>
                </kendo-grid-column>

                <div *kendoGridDetailTemplate="let dataItem">
                    <app-client-subscription-page
                        [type]="dataItem"
                        (edit)="toggleEditMenu(dataItem)"
                    ></app-client-subscription-page>
                </div>
            </kendo-grid>
        </ng-container>

        <ng-container *ngIf="tab === 1">
            <div class="employee-add-button-area">
                <button
                    mat-button
                    primary
                    outlined
                    [disabled]="!updateData || updateData.length <= 0"
                    (click)="update()"
                >
                    Save&nbsp;<span *ngIf="updateData && updateData.length > 0">
                        {{ updateData.length }} Changes</span
                    >
                </button>
                &nbsp;

                <mat-form-field fluid appearance="outline">
                    <mat-label>Search Clients</mat-label>

                    <input
                        matInput
                        [(ngModel)]="search"
                        class="search-field"
                        (ngModelChange)="filterSearch()"
                        [ngModelOptions]="{ standalone: true }"
                    />
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
            </div>
            <kendo-grid
                [data]="gridViewClients"
                [selectable]="true"
                style="height: auto"
                [pageSize]="pageSize"
                [skip]="skip"
                [headerClass]="'reports-header'"
                [headerStyle]="{
                    'text-align': 'left',
                    'background-color': '#223540',
                    color: '#FFFFFF',
                    'border-color': '#223540'
                }"
                [pageable]="{
                    info: info,
                    type: type,
                    pageSizes: true,
                    previousNext: previousNext
                }"
                [scrollable]="true"
                (pageChange)="clientPageChange($event)"
            >
                <kendo-grid-column
                    field="clientFullName"
                    title="Client Full Name"
                    [headerClass]="'header'"
                    [headerStyle]="{ 'text-align': 'left' }"
                    [class]="'text-color-black'"
                    [style]="{ 'text-align': 'left' }"
                    [footerClass]="'text-color-black'"
                    [footerStyle]="{ 'text-align': 'left' }"
                >
                </kendo-grid-column>

                <kendo-grid-column
                    title="Enrollment"
                    [headerClass]="'header'"
                    [headerStyle]="{
                        'text-align': 'left',
                        'background-color': '#223540',
                        color: '#FFFFFF',
                        'border-color': '#223540'
                    }"
                >
                    <ng-template kendoGridCellTemplate let-record>
                        <mat-select
                            outlined
                            class="custom-select-outline-color"
                            [(ngModel)]="record.clientSubscriptionTypeKey"
                            (ngModelChange)="updateSubscription(record)"
                        >
                            <mat-option
                                *ngFor="let sub of subscriptionType"
                                [value]="sub.clientSubscriptionTypeKey"
                            >
                                {{ sub.name }}
                            </mat-option>
                        </mat-select>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </ng-container>
    </div>
</mat-card>

<!-- Add Menu -->
<div id="subscription-background" *ngIf="addMenuOpen">
    <div id="subscription-menu">
        <div id="subscription-menu-header">
            <span>&nbsp;&nbsp;New Enrollment</span>
            <span
                (click)="toggleAddMenu()"
                style="float: right; padding-right: 15px; cursor: pointer"
            >
                <i class="fas fa-times"></i>
            </span>
        </div>

        <br />

        <p class="section-title">
            Create a new enrollment type group. Access can be modified once the group has been
            created.
        </p>

        <br />
        <table class="input-data-table">
            <tr>
                <td>
                    <mat-form-field fluid appearance="outline" class="input-form-field">
                        <input
                            matInput
                            placeholder="Name"
                            #nameField
                            [(ngModel)]="newSubscriptionModel.name"
                            class="text-field"
                            (change)="setNameField()"
                            maxlength="128"
                        />
                    </mat-form-field>
                    <div class="errors" *ngIf="hasName && !nameField.touched">
                        Enrollment name already taken, please choose another.
                    </div>
                    <div *ngIf="nameField.value.length == 0" class="error-message">*Required</div>
                </td>
            </tr>
            <tr>
                <td>
                    <mat-form-field fluid appearance="outline" class="input-form-field">
                        <input
                            matInput
                            placeholder="Description"
                            [(ngModel)]="newSubscriptionModel.description"
                            class="text-field"
                            maxlength="100"
                        />
                    </mat-form-field>
                </td>
            </tr>
            <tr style="padding-top: 10px">
                <td>
                    <label class="clone-text" style="display: inline-block">Clone Existing</label>
                    <p-checkbox [(ngModel)]="cloneFlag" [binary]="true" inputId="cloneCheck" />
                </td>
            </tr>
            <tr style="padding-top: 10px">
                <td>
                    <div id="permission-ddl">
                        <angular2-multiselect
                            *ngIf="cloneFlag"
                            [data]="subscriptionType"
                            [(ngModel)]="selectedSubscription"
                            [settings]="subscriptionListSettings"
                            (onSelect)="onItemSelect($event)"
                        >
                        </angular2-multiselect>
                    </div>
                </td>
            </tr>
        </table>

        <p
            *ngIf="errors && errors.length > 1"
            style="color: red; font-size: 14px; padding-left: 16px"
        >
            {{ errors }}
        </p>

        <br />

        <div width="150px" style="float: right; padding-top: 20px">
            <button mat-stroked-button (click)="toggleAddMenu()">Cancel</button>
            &nbsp;&nbsp;
            <button
                mat-stroked-button
                [disabled]="
                    cloneFlag == false &&
                    (newSubscriptionModel.name == null ||
                        newSubscriptionModel.name.length < 1 ||
                        hasName == true ||
                        submitting == true)
                "
                (click)="addSubscription()"
            >
                Save &nbsp;
                <i *ngIf="submitting" class="fa fa-spinner fa-spin"></i>
            </button>
        </div>
    </div>
</div>

<!-- Edit Menu -->
<div id="subscription-background" *ngIf="editMenuOpen">
    <div id="subscription-menu">
        <div id="subscription-menu-header">
            <i class="far fa-layer-group"></i>
            <span>&nbsp;&nbsp;Edit Enrollment</span>
            <span
                (click)="toggleEditMenu()"
                style="float: right; padding-right: 15px; cursor: pointer"
            >
                <i class="fas fa-times"></i>
            </span>
        </div>

        <br />

        <p class="section-title">
            Modify an enrollment type group. Access can be modified once the group has been created.
        </p>
        <!--<mat-form-field fluid appearance="outline" class="input-form-field">
        <input matInput
               placeholder="Description"
               [(ngModel)]="newSubscriptionModel.description"
               class="text-field"
               maxlength="100" />
    </mat-form-field>-->
        <table class="input-data-table">
            <tr>
                <td><label>Name</label></td>
                <td>
                    <mat-form-field fluid appearance="outline" class="input-form-field">
                        <!--<mat-label>Name</mat-label>-->
                        <input matInput [(ngModel)]="editSubscriptionModel.name" />
                    </mat-form-field>

                    <!--<mat-form-field fluid appearance="outline" class="input-form-field">
                    <input matInput
                           placeholder="Description"
                           [(ngModel)]="newSubscriptionModel.description"
                           class="text-field"
                           maxlength="100" />
                </mat-form-field>-->
                </td>
            </tr>
            <tr>
                <td><label>Description</label></td>
                <td>
                    <mat-form-field fluid appearance="outline" class="input-form-field">
                        <!--<mat-label>Description</mat-label>-->
                        <input matInput [(ngModel)]="editSubscriptionModel.description" />
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td><label>Active</label></td>
                <td>
                    <p-checkbox [(ngModel)]="editSubscriptionModel.isActive" [binary]="true" />
                    <!--<input matInput type="checkbox" [(ngModel)]="editSubscriptionModel.isActive" />-->
                </td>
            </tr>
        </table>

        <p
            *ngIf="errors && errors.length > 1"
            style="color: red; font-size: 14px; padding-left: 16px"
        >
            {{ errors }}
        </p>
        <br />
        <div width="150px" style="float: right; padding-top: 20px">
            <button mat-stroked-button (click)="toggleEditMenu()">Cancel</button>
            &nbsp;&nbsp;
            <button
                mat-stroked-button
                primary
                [disabled]="
                    editSubscriptionModel.name == null || editSubscriptionModel.name.length < 3
                "
                (click)="editSubscription()"
            >
                Save &nbsp;
                <i class="far fa-save"></i>
            </button>
        </div>
    </div>
</div>
